import SignupForm from '@modules/auth/components/pages/SignupForm';
import withAuth, { AUTH_MODE } from '@modules/auth/hocs/withAuth';
import Routes from '@common/defs/routes';
import { ReactElement, useEffect } from 'react';
import { NextPageWithLayout } from 'src/pages/_app';
import { useTracking } from '@common/hooks/useTracking';

const RegisterPage: NextPageWithLayout<Record<string, unknown>> = () => {
  const { trackEvent } = useTracking();
  useEffect(() => {
    trackEvent('auth.register_page_view');
  }, []);
  return <SignupForm />;
};

RegisterPage.getLayout = (page: ReactElement) => {
  return <>{page}</>;
};

export default withAuth(RegisterPage, {
  mode: AUTH_MODE.LOGGED_OUT,
  redirectUrl: Routes.Common.Home,
});
